module.exports = __webpack_public_path__ + "static/media/jenis_ekstrakulikuler.2a49d790.png";